export default __webpack_public_path__ + "static/media/onion-bw.94ee1c9d.svg";